module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Definicija (Laboratorium).e28c4b6e.mp3";